import React, {useState, useEffect} from "react";

// Importing images
import BoucMediaWhite from "../assets/img/BoucMedia_White_3_1296x.webp";
import tvIcon from "../assets/icon/tv.webp";
import phoneIcon from "../assets/icon/phone.webp";
import boxIcon from "../assets/icon/box.webp";
import roIcon from "../assets/icon/rock.webp";
import womenImage from "../assets/img/women.webp";
import mainFon from "../assets/img/mainFon.webp";
import Label from "./Label";
import {useNavigate} from "react-router-dom";
import {motion} from 'framer-motion';

import Carousel from 'react-multi-carousel';
import FormModal from "../components/FormModal";

const responsive = {
    desktop: {
        breakpoint: {max: 3000, min: 1024},
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
        breakpoint: {max: 1024, min: 464},
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
        breakpoint: {max: 464, min: 0},
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

const testimonialsData = [
    {
        title: 'Bouc',
        content: 'Bouc grew my client to 20,000 followers in 30 days through influencer marketing!',
        name: 'Alek Uzunovic',
        date: '2/21/2020',
        rating: 5
    },
    {
        title: 'Recommend',
        content: 'Professional, fast, and over 15k followers so far. Highly recommended!',
        name: 'Isaac Chanakira',
        date: '2/26/2019',
        rating: 5
    },
    {
        title: '10/10',
        content: 'Since working with Christien, I\'ve doubled my revenue incorporating Bouc services to clients',
        name: 'Murphi Kennedy',
        date: '5/25/2020',
        rating: 5
    }
];

function ExampleReactComponent() {
    const [services, setServices] = useState([]);
    let navigate = useNavigate();
    const [pause, setPause] = useState(false);

    const [isAnimated, setIsAnimated] = useState(false);

    const [modalIsOpen, setIsOpen] = useState(false);

    //
    // [
    //     {img: tvIcon, title: "Paid Advertising", price: "$1,500"},
    //     {img: phoneIcon, title: "Consultation", price: "$197"},
    //     {img: boxIcon, title: "Web Design & Development", price: "$3,000"},
    //     {img: roIcon, title: "Lead Generation", price: "$500"},
    // ]
    // Хук для загрузки данных из API
    const [currentIndex, setCurrentIndex] = useState(0);
    // Переход к следующему слайду
    const nextSlide = () => {
        setCurrentIndex((prev) => (prev + 1) % slides.length);
    };

    // Переход к предыдущему слайду
    const prevSlide = () => {
        setCurrentIndex((prev) =>
            prev - 1 < 0 ? slides.length - 1 : prev - 1
        );
    };

    // Перейти к конкретному слайду (при клике по "точке")
    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    useEffect(() => {
        fetch("/wp-json/wp/v2/posts?categories=2&per_page=4")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch services.");
                }
                return response.json();
            })
            .then((data) => {
                const formattedServices = data.map((post) => ({
                    id: post.id,
                    title: post.title.rendered,
                    content: post.content.rendered,
                    price: post?.meta?.service_price,
                    img: post.featured_media_url || tvIcon,
                }));
                setServices(formattedServices);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching services:", error);
                setError(error.message);
                setLoading(false);
            });
    }, []);
    return (
        <>
            <Label>


                <section className="video-main">
                    <div className="video-main-bk" style={{backgroundImage: `url(${mainFon})`}}>
                        {
                            !pause && (
                                <video
                                    className="slideshow__video slideshow__video--1486583739899"
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                >
                                    <source src="https://boucmedia.com/vback.mp4" type="video/mp4"/>
                                </video>
                            )
                        }


                        <motion.div
                            className="our-services-more"
                            // Начальное состояние
                            initial={{opacity: 0, y: 50}}
                            // Состояние при попадании в зону видимости
                            whileInView={{opacity: 1, y: 0}}
                            // Настройки анимации
                            transition={{duration: 0.5}}
                            // Чтобы Framer Motion понимал, когда элемент во вьюпорте
                            viewport={{once: true /* анимация сработает один раз */}}
                        >
                            <div className="slideshow__text-container page-width">
                                <div className="slideshow__text-content has-animated" data-animate="">
                                    <button onClick={() => {
                                        setPause(!pause);
                                    }} className={"btn-play btn--clear " + (pause && 'is-paused')}>
                <span className="visually-hidden" data-play-label="">
                  Play video
                </span>
                                        <span className="slideshow__play-button-icon"></span>
                                        <span className="slideshow__play-button-circle"></span>
                                    </button>
                                    <h1 className="slideshow__heading h1 main-h1-text">Bouc Media <br/>
                                        Is Disruptive Marketing</h1>

                                    <a href="/services/" className="slideshow__heading-cta btn">
                                        Get Started
                                    </a>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </section>

                <FormModal onClose={() => {
                    setIsOpen(false);
                }} modalIsOpen={modalIsOpen}/>


                <section className="company-info">
                    <div className="container company-info-main">
                        <div className="company-info-logo">
                            <div
                                className="logo-big"
                                style={{backgroundImage: `url(${BoucMediaWhite})`}}
                            ></div>
                        </div>
                        <div className="company-info-text">
                            <motion.div
                                className="company-info-text-line"
                                // Начальное состояние
                                initial={{opacity: 1, width: 0}}
                                // Состояние при попадании в зону видимости
                                whileInView={{opacity: 1, width: 80}}
                                // Настройки анимации
                                transition={{duration: 0.5}}
                                // Чтобы Framer Motion понимал, когда элемент во вьюпорте
                                viewport={{once: true /* анимация сработает один раз */}}
                            >
                            </motion.div>
                            <h2>Bouc Media</h2>


                            <p>
                                <b>Bouc Media</b> is a social media marketing agency that
                                specializes in lead generation and PR. Founder Christien Bouc and
                                his team are on a mission to help influencers and companies scale
                                their business online!
                            </p>

                            <button onClick={() => {
                                navigate('/about/');
                            }} className="btn btn-inv">Learn More
                            </button>
                        </div>
                    </div>
                </section>


                <section className="our-services">
                    <div className="container">
                        <div className="our-services-box">
                            <div className="our-services-head">
                                <h2>Our Services</h2>
                            </div>
                            <div className="our-services-body ">
                                {services.slice(0, 4).map((service, index) => {
                                    return (
                                        <motion.div
                                            className="our-services-item"
                                            // Начальное состояние

                                            initial={{opacity: 0, y: 50}}
                                            // Состояние при попадании в зону видимости
                                            whileInView={{opacity: 1, y: 0}}
                                            // Настройки анимации
                                            transition={{duration: 0.5, delay: ((0.2 * index))}}
                                            // Чтобы Framer Motion понимал, когда элемент во вьюпорте
                                            viewport={{once: true /* анимация сработает один раз */}}
                                        >
                                            <a href={`/services/${service.id}`}
                                               style={{width: "100%", textDecoration: "none"}}
                                               key={service.id}>
                                                <img src={service.img} alt={service.title}/>
                                                <h4 className="card__name"
                                                    dangerouslySetInnerHTML={{__html: service.title}}></h4>
                                                {service.price && (
                                                    <p className="card__price">
                                                        ${parseInt(service.price).toLocaleString('en-US')}
                                                    </p>
                                                )}
                                            </a>
                                        </motion.div>
                                    )
                                })}
                            </div>

                            <div className="our-services-more">
                                <a href={'/services'} className="btn btn-def">VIEW ALL</a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="promotions">
                    <div className="container promotions-padding">
                        <div className="promotions-box">
                            <div className="promotions-box-img">
                                <div className="promotions-box-padding">
                                    <div
                                        className="promotions-box-img-src"
                                        style={{backgroundImage: `url(${womenImage})`}}
                                    ></div>
                                </div>
                            </div>
                            <div className="promotions-box-text">
                                <h3>Celebrity Promotions</h3>
                                <p>
                                    Get promos on Twitter & Tiktok with some of the hottest USA &
                                    International celebrities ranging from Jake Paul to even the
                                    Kardashians. Celebrity Advertising Is 2022!
                                </p>
                                <br/>

                                {/*<a href={'https://x.com/christienbouc_'} target={'_blank'}*/}
                                {/*   className="btn btn-up btn-def">*/}
                                {/*    See Up Coming Campaigns*/}
                                {/*</a>*/}
                                <button onClick={()=>{
                                    setIsOpen(true);
                                }}
                                   className="btn btn-up btn-def">
                                    See Up Coming Campaigns
                                </button>
                            </div>


                            <motion.div
                                className={`highlight__border ${isAnimated ? "has-animated" : ""}`}
                                onViewportEnter={() => setIsAnimated(true)}
                                viewport={{once: true}}
                            >
                                <div className="highlight__line highlight__line--top"></div>
                                <div className="highlight__line highlight__line--right"></div>
                                <div className="highlight__line highlight__line--bottom"></div>
                                <div className="highlight__line highlight__line--left"></div>
                            </motion.div>
                        </div>


                    </div>
                </section>
                <section className="testimonials">
                    <div className="testimonials-box">
                        <div className="testimonials-box-head">
                            <h3>Testimonials</h3>
                        </div>

                        <Carousel
                            swipeable={false}
                            draggable={true}
                            showDots={true}
                            responsive={responsive}
                            ssr={true} // means to render carousel on server-side.
                            infinite={true}
                            autoPlaySpeed={1000}
                            keyBoardControl={true}
                        >
                            {
                                testimonialsData.map((testimonial, index) => {
                                    return (
                                        <div key={1} className="testimonials-box-body testimonials-slide">
                                            <div className="testimonials-slide-body">
                                                <p className="testimonials-item">
                                                    <b>{testimonial.title}</b>
                                                    <span>
                {testimonial.content}
                </span>
                                                </p>
                                            </div>
                                            <div className="testimonials-slide-icon"></div>
                                            <div className="testimonials-slide-info">
                                                <span>{testimonial.name}</span>
                                                <span>{testimonial.date}</span>
                                            </div>
                                        </div>
                                    );
                                })
                            }


                        </Carousel>

                    </div>
                </section>
                <section className="e-book">
                    <div className="container">
                        <div className="e-book-box">
                            <div className="e-book-title">
                                <h2>FREE Growth eBook</h2>
                            </div>
                            <div className="e-book-box-body">
                                <p>
                                    An emailed copy of our Growth eBook, "20 secrets for Social Growth", which includes
                                    multiple tips
                                    and secrets that took years for us to crack the code on social growth!
                                </p>
                            </div>
                            <div className="input-group--underline has-animated" data-animate="">
                                <input
                                    type="email"
                                    value=""
                                    placeholder="My email address"
                                    name="contact[email]"
                                    className="input-group__field"
                                    id="EmailField1592009598827"
                                    aria-label="My email address"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                />
                                <div className="input-group__btn input-group__btn--newsletter">
                                    <button type="submit" className="btn--newsletter__submit">
                                        Subscribe
                                        <svg
                                            aria-hidden="true"
                                            focusable="false"
                                            role="presentation"
                                            className="icon icon-arrow-right"
                                            viewBox="0 0 4 7"
                                        >
                                            <path fill="#444" d="M4 3.5L0 7V0z"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </Label>
        </>
    );
}

export default ExampleReactComponent;